// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid #E4E5E8;
  border-radius: 0 0 2px 2px;
  min-width: 420px;
  border-radius: 8px;
}
@media (max-width: 768px) {
  :host {
    min-width: 0;
    width: calc(100% - 24px);
    margin: 0 12px;
  }
}
:host:empty {
  display: none;
}
:host .stat {
  flex: 1 0 136px;
}
@media (max-width: 768px) {
  :host .stat {
    flex: 1;
  }
}
:host .stat + .stat {
  border-left: 1px solid #E4E5E8;
}
:host .stat .header {
  color: #1A1E29;
  padding: 10px 12px 12px;
}
:host .stat .header h3 {
  font-weight: 700;
  font-family: "RM Neue";
  font-size: 10px;
  line-height: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
:host .stat .header .value {
  margin-top: 12px;
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 32px;
  line-height: 32px;
  text-align: center;
}
:host .stat .header .value span {
  display: block;
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 10px;
  line-height: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #787D8B;
  margin-top: 8px;
}
:host .stat .detail {
  display: flex;
  align-items: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background-color: #F2F2F4;
  color: #1A1E29;
  padding-top: 8px;
  padding-bottom: 12px;
}
@media (max-width: 768px) {
  :host .stat .detail {
    padding: 8px;
  }
}
:host .stat .detail p {
  font-weight: 300;
  font-family: "RM Neue";
  font-size: 16px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 0;
  color: #5E6A83;
}
:host .stat .detail p .total {
  color: #0F2145;
}
:host .stat .detail p .accuracy {
  display: block;
  height: 12px;
  width: 12px;
  border-radius: 2px;
  margin: 0 8px;
}
@media (max-width: 768px) {
  :host .stat .detail p .accuracy {
    margin: 0 4px 0 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/stats/shots-summary/shots-summary.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,oBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;AADF;AAEE;EAPF;IAQI,YAAA;IACA,wBAAA;IACA,cAAA;EACF;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AACI;EAFF;IAGI,OAAA;EAEJ;AACF;AAAI;EACE,8BAAA;AAEN;AACI;EACE,cCvBM;EDwBN,uBAAA;AACN;AACM;EC8BF,gBAAA;EAMA,sBAAA;EDlCI,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAER;AACM;EACE,gBAAA;ECeJ,gBAAA;EAUA,sBAAA;EDvBI,eAAA;EACA,iBAAA;EACA,kBAAA;AAER;AAAQ;EACE,cAAA;ECQN,gBAAA;EAUA,sBAAA;EDhBM,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cC7CC;ED8CD,eAAA;AAGV;AAEI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBCrDK;EDsDL,cChEM;EDiEN,gBAAA;EACA,oBAAA;AAAN;AAEM;EAZF;IAaI,YAAA;EACN;AACF;AACM;ECtBF,gBAAA;EAYA,sBAAA;EDYI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,cC9CS;ADgDjB;AADQ;EACE,cCjDO;ADoDjB;AAAQ;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAEV;AAAU;EAPF;IAQI,mBAAA;EAGV;AACF","sourcesContent":["@import 'theme';\n\n:host {\n  display: inline-flex;\n  align-items: stretch;\n  border: 1px solid $colorN10;\n  border-radius: 0 0 2px 2px;\n  min-width: 420px;\n  border-radius: 8px;\n  @media (max-width: $mobileBreakpoint) {\n    min-width: 0;\n    width: calc(100% - 24px);\n    margin: 0 12px;\n  }\n\n  &:empty {\n    display: none;\n  }\n\n  .stat {\n    flex: 1 0 136px;\n    @media (max-width: $mobileBreakpoint) {\n      flex: 1;\n    }\n\n    & + .stat {\n      border-left: 1px solid $colorN10;\n    }\n\n    .header {\n      color: $colorN100;\n      padding: 10px 12px 12px;\n\n      h3 {\n        @include font(bold, condensed);\n        font-size: 10px;\n        line-height: 10px;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n\n      .value {\n        margin-top: 12px;\n        @include font(normal, condensed);\n        font-size: 32px;\n        line-height: 32px;\n        text-align: center;\n\n        span {\n          display: block;\n          @include font(normal, condensed);\n          font-size: 10px;\n          line-height: 10px;\n          text-transform: uppercase;\n          letter-spacing: 1px;\n          color: $colorN50;\n          margin-top: 8px;\n        }\n      }\n    }\n\n    .detail {\n      display: flex;\n      align-items: center;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 12px;\n      background-color: $colorN05;\n      color: $colorN100;\n      padding-top: 8px;\n      padding-bottom: 12px;\n\n      @media (max-width: $mobileBreakpoint) {\n        padding: 8px;\n      }\n\n      p {\n        @include font(light, condensed);\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n        flex-grow: 0;\n        color: $colorGreyLabel;\n        .total {\n          color: $colorGreyTitle;\n        }\n\n        .accuracy {\n          display: block;\n          height: 12px;\n          width: 12px;\n          border-radius: 2px;\n          margin: 0 8px;\n\n          @media (max-width: $mobileBreakpoint) {\n            margin: 0 4px 0 8px;\n          }\n        }\n      }\n    }\n  }\n}\n","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
